import { Grid } from '@material-ui/core';
import React from 'react';

import PageContentWrap from '../../../../components/Common/PageContentWrap';
import { PrepaySettingsForm } from '../../../widgets/prepaySettingsForm';

export const PrepaySettings = () => (
  <PageContentWrap>
    <Grid item xs={12} lg={9}>
      <PrepaySettingsForm />
    </Grid>
  </PageContentWrap>
);
